import { Action } from '@ngrx/store';
import { navigateToExternalPage } from '../../../../core/store/actions/app.actions';
import { NavListItem } from '../models/nav-list-item';

export function getNavDispatchAction(navListItem: NavListItem): Action | null {
  if (navListItem.action) {
    return navListItem.action;
  }

  if (navListItem.isExternal && navListItem.externalUrlTypeId !== undefined) {
    return navigateToExternalPage({ externalUrlTypeId: navListItem.externalUrlTypeId });
  }

  return null;
}

export function getNavRoute(navListItem: NavListItem, patientId?: number): string | null {
  if (!navListItem.route) {
    return null;
  }

  return navListItem.isGuardedRoute ? `patient/${patientId}/${navListItem.route}` : navListItem.route;
}

export function getNavRouteToMatch(navListItem: NavListItem, patientId?: number): string | null {
  if (!navListItem.route) {
    return null;
  }

  return navListItem.isGuardedRoute ? `/patient/${patientId}/${navListItem.route}` : `/${navListItem.route}`;
}
